import { transformRoutes } from '@backoffice-frontend/common'

const baseRoute = '/shifts'

export const BaseShiftAreaRoutes = {
  route: baseRoute,
  ShiftOverviewDashboard: {
    route: '/overview',
    ById: {
      route: '/:shiftId',
    },
  },
  ShiftsDemandSupply: {
    route: '/supply',
  },
  ShiftsActivities: {
    route: '/activities',
  },
}

export const ShiftsAreaRoutes = transformRoutes(BaseShiftAreaRoutes)
